const article = {
    slug: "noir-kei-ninomiya",
    category: "BRAND BUYBACK",
    listTitle: "NOIR KEI NINOMIYA買取",
    listDescription:
      "チュール、ハーネス、構築的ドレス、アーカイブ作品まで、ノワールケイニノミヤの造形価値を見て査定する専用買取ページ。",
    seo: {
      title:
        "NOIR KEI NINOMIYA買取｜ノワールケイニノミヤを価値まで査定するEnclopedia",
      description:
        "NOIR KEI NINOMIYA（ノワールケイニノミヤ）の買取ならEnclopediaへ。チュール、オーガンジー、フリル、ハーネス、ドレス、スカート、構築的ジャケットなどを、シーズン背景・造形性・希少性まで見て査定。LINE事前査定から全国対応の宅配買取へご案内します。",
      keyword:
        "NOIR KEI NINOMIYA 買取,noir kei ninomiya 買取,ノワールケイニノミヤ 買取,ノワール ケイ ニノミヤ 買取,コムデギャルソン ノワールケイニノミヤ 買取,NOIR KEI NINOMIYA 高価買取,ノワールケイニノミヤ 高価買取,NOIR KEI NINOMIYA 宅配買取,ノワールケイニノミヤ 宅配買取,NOIR KEI NINOMIYA LINE査定,ノワールケイニノミヤ 買取相場,NOIR KEI NINOMIYA アーカイブ 買取,チュールドレス 買取,ハーネス 買取,アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/noir-kei-ninomiya",
    },
    hero: {
      label: "NOIR KEI NINOMIYA BUYBACK",
      number: "06 / BUYBACK",
      titleLines: [
        "NOIR KEI NINOMIYA買取。",
        "造形と技法の価値まで見て査定します。",
      ],
      body:
        "Enclopediaは、NOIR KEI NINOMIYAをブランド名だけで一律に判断しません。\nチュール、オーガンジー、フリル、ハーネス、レーザーカット、構築的ドレスなど、ノワールケイニノミヤならではの素材表現と造形性を確認し、個々のアイテムにフォーカスして査定します。\nまずはLINEで無料の事前査定。納得いただけた方を、全国対応の宅配買取へご案内します。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "buyback",
        "sculptural construction",
        "tulle dress",
        "noir kei ninomiya",
      ],
      visualLabel: "ARCHIVE VALUATION",
      visualTitle: [
        "装飾ではなく、",
        "造形としての価値を見る。",
      ],
      image: "media/archive_fashion/buyback6.png",
      imageAlt: "NOIR KEI NINOMIYA買取のメイン画像",
    },
    thesis: {
      text:
        "NOIR KEI NINOMIYAの価値は、人気だけでなく、素材の接続・構築性・シーズン背景まで見て判断する。",
      keywords: ["construction", "material", "rarity"],
    },
    intro: {
      label: "02 / OUR BUYBACK VIEW",
      titleLines: [
        "ノワールケイニノミヤの価値は、",
        "“黒い服”の一言では終わらない。",
      ],
      body:
        "NOIR KEI NINOMIYAは、黒を軸にしながら、素材・技法・立体構造によって服の表情を拡張してきたブランドです。\nチュールやオーガンジー、フリル、リボン、ハーネス状の構成、糸を使わない接続、レーザーカット的な造形。\nEnclopediaでは、単に人気モデルかどうかではなく、その一着がどのような技術と造形で成立しているか、どの時期の表現かまで確認して査定します。",
    },
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: [
        "Enclopediaが重視する、",
        "3つの査定視点。",
      ],
      items: [
        {
          number: "01",
          title: "素材表現と構築性を見る",
          text:
            "チュール、オーガンジー、フリル、レース、ハーネス、パーツ接続など、NOIR KEI NINOMIYAらしい立体的な造形を確認します。",
        },
        {
          number: "02",
          title: "シーズン背景と作品性を見る",
          text:
            "近年作か過去作かだけでなく、コレクションの中でどのような位置を持つアイテムかを見ながら判断します。",
        },
        {
          number: "03",
          title: "希少性と現在需要を見る",
          text:
            "流通量、サイズ、保存状態、人気デザイン、国内外の再販需要を踏まえ、個別に査定します。",
        },
      ],
    },
    targetLines: {
      label: "04 / TARGET ITEMS",
      titleLines: [
        "NOIR KEI NINOMIYA全般を、",
        "幅広く査定します。",
      ],
      items: [
        {
          tag: "ITEM 01",
          title: "チュール・オーガンジー系ドレス",
          text:
            "ブランドを象徴する立体的なドレス、透け感のあるレイヤード、ボリューム表現の強い作品を査定します。",
        },
        {
          tag: "ITEM 02",
          title: "フリル・リボン・レース装飾",
          text:
            "甘さではなく構築性として装飾を扱うアイテムを、デザインの密度と需要を踏まえて評価します。",
        },
        {
          tag: "ITEM 03",
          title: "ハーネス・チェーン・立体パーツ",
          text:
            "ハーネスベスト、チェーン接続、パーツ構成が特徴的なアイテムは、NOIRらしさが強く出る領域です。",
        },
        {
          tag: "ITEM 04",
          title: "ジャケット・コート・MA-1",
          text:
            "チュール重ね、異素材切替、装飾性の高いアウター類は、状態と希少性を確認して査定します。",
        },
        {
          tag: "ITEM 05",
          title: "スカート・パンツ・ボトムス",
          text:
            "フリルスカート、プリーツスカート、ボリュームパンツなど、構造性のあるボトムスも対象です。",
        },
        {
          tag: "ITEM 06",
          title: "ブラウス・トップス・カットソー",
          text:
            "フリルブラウス、チュールトップス、特殊素材使いのTシャツやカットソーも査定可能です。",
        },
        {
          tag: "ITEM 07",
          title: "アクセサリー・ハーネス小物",
          text:
            "衣服の延長としてデザインされた装飾小物やハーネス系アイテムも内容に応じて見ます。",
        },
        {
          tag: "ITEM 08",
          title: "過去シーズンのアーカイブ",
          text:
            "古いだけで高くなるわけではありませんが、現在も評価される造形性の強い作品はアーカイブ価値まで見ます。",
        },
      ],
    },
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: [
        "高価買取につながりやすい、",
        "NOIR KEI NINOMIYAのアイテム。",
      ],
      intro:
        "査定額は状態や相場で変動しますが、Enclopediaでは特に以下のようなノワールケイニノミヤを丁寧に確認します。",
      items: [
        {
          index: "01",
          title: "チュール・オーガンジーを用いたドレスやワンピース",
          text:
            "ブランドの魅力が最も強く出やすい領域です。ボリューム、構築性、装飾密度、保存状態を総合して査定します。",
        },
        {
          index: "02",
          title: "ハーネス・チェーン・レーザーカット的構造を持つ作品",
          text:
            "NOIR KEI NINOMIYAらしい技法と造形が明確に現れる作品は、単なる衣類としてではなくデザイン価値を見ます。",
        },
        {
          index: "03",
          title: "フリルスカート・構築的ブラウス・立体ジャケット",
          text:
            "中古市場でも検索されやすい人気カテゴリ。需要が継続している品は丁寧に評価します。",
        },
        {
          index: "04",
          title: "近年シーズンの人気作・市場流通が少ない品",
          text:
            "現行人気が高い作品や、流通量が限られる希少作は、現在の再販需要を踏まえて判断します。",
        },
        {
          index: "05",
          title: "保存状態の良いアーカイブ作品",
          text:
            "繊細な素材を使うブランドだからこそ、チュール破れ、パーツ欠け、装飾状態を確認したうえで価値を見ます。",
        },
      ],
    },
    quote: {
      textLines: [
        "“可愛い装飾”としてではなく、",
        "黒を構築する服として見る。",
      ],
    },
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: [
        "一般的な査定で、",
        "見落とされやすいNOIRの価値。",
      ],
      intro:
        "NOIR KEI NINOMIYAは、素材の繊細さと造形の強さが同時に存在するため、一般的なブランド古着査定だけでは価値が平準化されやすいブランドです。",
      items: [
        {
          index: "01",
          title: "“装飾が多い服”として片付けない",
          text:
            "フリルやチュールは単なる装飾ではなく、服の骨格を形づくる要素です。造形としてどの程度完成度が高いかを見ます。",
        },
        {
          index: "02",
          title: "素材の特殊性を査定に反映する",
          text:
            "チュール、オーガンジー、メッシュ、硬質パーツなど、一般的な服とは異なる保存性・希少性を確認します。",
        },
        {
          index: "03",
          title: "アーカイブ性と次の着用価値を見る",
          text:
            "Enclopediaはアーカイブのレンタル・共有を行うため、次の着用者へ渡る価値があるかという視点も持って査定します。",
        },
      ],
    },
    flow: {
      label: "07 / BUYBACK FLOW",
      titleLines: [
        "LINE事前査定から、",
        "宅配買取へ。",
      ],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "写真と簡単な情報をお送りください。素材感、全体像、ブランドタグ、装飾部分が分かる写真があると確認しやすくなります。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "本査定をご希望の場合は申込フォームへ。宅配キットの要否もここで選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。繊細な装飾やチュールがある場合は、なるべく形を崩さない梱包をおすすめします。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "到着後に状態・真贋・需要・造形価値を確認。金額にご納得いただければご指定口座へ入金します。",
        },
      ],
    },
    assurance: {
      label: "08 / SAFE BUYBACK",
      titleLines: [
        "相談しやすく、",
        "進めやすいNOIR KEI NINOMIYA買取。",
      ],
      intro:
        "LINEで相談してから進められるため、繊細な素材や特殊構造のアイテムも、宅配買取へ進む前に確認できます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "まず相談してから進められるため、特殊構造の服も安心してご相談いただけます。",
        },
        {
          title: "送料は無料",
          text:
            "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合はそのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
    faq: {
      label: "09 / FAQ",
      titleLines: [
        "NOIR KEI NINOMIYA買取で、",
        "よくあるご質問。",
      ],
      items: [
        {
          question:
            "どのNOIR KEI NINOMIYAアイテムを買取していますか？",
          answer:
            "ドレス、ワンピース、スカート、ブラウス、トップス、ジャケット、コート、MA-1、ハーネスベスト、装飾小物など幅広くご相談いただけます。",
        },
        {
          question:
            "チュールやオーガンジーのドレスも査定できますか？",
          answer:
            "はい。NOIR KEI NINOMIYAを代表する重要なカテゴリとして、状態・造形性・需要を確認して査定します。",
        },
        {
          question:
            "ハーネスやチェーンを使った特殊なアイテムも買取対象ですか？",
          answer:
            "はい。ハーネス、チェーン、立体パーツ、レーザーカット的な構造を持つ作品も、ブランド性を踏まえて確認します。",
        },
        {
          question:
            "ノワールケイニノミヤの買取相場を先に知りたいです。",
          answer:
            "状態やシーズン、デザイン、需要によって異なるため、まずはLINEで写真をお送りください。宅配買取へ進む前に、おおまかな方向性をご案内します。",
        },
        {
          question:
            "古いNOIR KEI NINOMIYAのアーカイブも査定できますか？",
          answer:
            "はい。年代だけで一律には判断せず、現在の需要、希少性、造形性を踏まえて個別に評価します。",
        },
        {
          question:
            "LINE査定をせずに宅配買取を申し込めますか？",
          answer:
            "申込自体は可能ですが、事前にLINE査定をご利用いただくことで、査定可否や大まかな評価方針を確認しやすくなります。",
        },
      ],
    },
    finalCta: {
      titleLines: [
        "まずはLINEで、",
        "NOIR KEI NINOMIYAの価値をご相談ください。",
      ],
      body:
        "チュール、ハーネス、構築的ドレス、アーカイブ作品まで確認。\nEnclopediaが、造形の価値を見て宅配買取へ丁寧につなげます。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };

export default article;
